module.exports = __webpack_public_path__ + "img/flippay-logo.b1c84387.svg";